// extracted by mini-css-extract-plugin
module.exports = {"list":"ProposalsByStatus_list__14Oon","link":"ProposalsByStatus_link__3K1nV"};